import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import Icon from '../components/Icon';
import { Input, Button } from '../components/UI';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) return;
    setError('');
    setLoading(true);
    try {
      const { data } = await authAPI.login(username, password);
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || "Login yoki parol noto'g'ri");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleLogin(); };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 40%, #f5f3ff 100%)', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: '8%', right: '20%', width: 350, height: 350, borderRadius: '50%', background: 'rgba(99,102,241,0.06)', animation: 'float 8s ease-in-out infinite' }} />
      <div style={{ position: 'absolute', bottom: '15%', left: '10%', width: 200, height: 200, borderRadius: '50%', background: 'rgba(139,92,246,0.05)', animation: 'float 10s ease-in-out infinite 3s' }} />

      <div className="fade-up" onKeyDown={handleKeyDown} style={{ width: '100%', maxWidth: 440, padding: '48px 40px', borderRadius: 24, background: '#fff', boxShadow: '0 20px 60px rgba(99,102,241,0.1), 0 0 0 1px rgba(99,102,241,0.06)', position: 'relative', zIndex: 1, margin: '0 16px' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ width: 52, height: 52, borderRadius: 16, background: 'linear-gradient(135deg, var(--accent), var(--violet))', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff', boxShadow: '0 8px 24px rgba(99,102,241,0.3)', marginBottom: 16 }}>
            <Icon name="shield" size={24} />
          </div>
          <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6, letterSpacing: '-0.02em' }}>Yoshlar Platformasi</h1>

        </div>

        {/* OneID Button */}
        <button style={{
          width: '100%', padding: '15px 20px', borderRadius: 12, border: 'none',
          background: '#1a7fd4',
          color: '#fff', fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 24, letterSpacing: '0.02em',
          transition: 'all .2s',
        }}
          onMouseEnter={e => { e.currentTarget.style.background = '#1570c0'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#1a7fd4'; }}
        >
          OneID orqali kirish
        </button>

        {/* Divider */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
          <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
          <span style={{ fontSize: 11, color: 'var(--text-dim)' }}>yoki</span>
          <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
        </div>

        {error && <div style={{ padding: '10px 16px', borderRadius: 10, background: '#fee2e2', color: 'var(--red)', fontSize: 13, fontWeight: 500, marginBottom: 16, textAlign: 'center' }}>{error}</div>}

        <Input label="Login" value={username} onChange={setUsername} placeholder="admin@yoshlar.uz" />
        <Input label="Parol" value={password} onChange={setPassword} type="password" placeholder="••••••••" />

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
          <span style={{ fontSize: 13, color: 'var(--accent)', fontWeight: 500, cursor: 'pointer' }}>Parolni unutdim?</span>
        </div>

        <Button onClick={handleLogin} disabled={loading || !username || !password} style={{ width: '100%' }}>
          {loading ? "Tekshirilmoqda..." : "Kirish"} {!loading && <Icon name="arrow" size={18} color="#fff" />}
        </Button>


      </div>
    </div>
  );
}
